import { GridFilterItem } from "@mui/x-data-grid";

import { IFilterItem } from "../types/filters";

export const adaptBeFilterToMuiFilter = (beFilter: IFilterItem): GridFilterItem => {
  let operatorValue: string = beFilter.operator;

  if (beFilter.operator === "isLessOrEqualTo") {
    operatorValue = "<=";
  } else if (beFilter.operator === "isGreaterOrEqualTo") {
    operatorValue = ">=";
  }

  return {
    id: beFilter.id,
    columnField: beFilter.name,
    operatorValue,
    value: beFilter.value,
  };
};

export const adaptMuiFilterToBeFilter = (muiFilter: GridFilterItem): IFilterItem => {
  return {
    id: muiFilter.id !== undefined ? String(muiFilter.id) : "",
    name: muiFilter.columnField,
    operator: muiFilter.operatorValue as IFilterItem["operator"],
    value: muiFilter.value,
  };
};
